import { combineReducers } from 'redux';
import hubUsers from 'ui-forms-editor-automation-lib/reducers/hubUsers';
import teams from 'ui-forms-editor-automation-lib/reducers/teams';
import notificationPreferences from 'ui-forms-editor-automation-lib/reducers/notificationPreferences';
import parentApplication from 'ui-forms-editor-automation-lib/reducers/parentApplication';
import workflowCreation from 'ui-forms-editor-automation-lib/reducers/workflowCreation';
import flows from 'ui-forms-editor-automation-lib/reducers/flows';
import websiteFlows from 'ui-forms-editor-automation-lib/reducers/websiteFlows';
import formDependencies from 'ui-forms-editor-automation-lib/reducers/formDependencies';
import flowUsages from 'ui-forms-editor-automation-lib/reducers/flowUsages';
export default {
  automationTab: combineReducers({
    hubUsers,
    teams,
    notificationPreferences,
    parentApplication,
    workflowCreation,
    flows,
    websiteFlows,
    formDependencies,
    flowUsages
  })
};